import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import procedure from '@/components/examine/procedure.vue';
import schedule from '@/components/examine/schedule.vue';
import operation from '@/views/examine/components/operation.vue';
import sharedNode from '@/views/examine/components/sharedNode.vue';
import claimsInfo from '@/views/claim/customerRecordManage/recordFrom/claimsInfo2.vue';
import perfectInfo from '@/views/claim/customerRecordManage/perfectInfo2.vue';
import { auditScheduleResource } from '@/views/examine/typeManage/request';
import { auditSchedule, auditDetail, auditOperate } from './request';
import { recursionCopy } from '@/views/customer/roleManage/utils';
export default {
  components: {
    procedure,
    schedule,
    perfectInfo,
    claimsInfo,
    operation,
    sharedNode
  },
  data() {
    return {
      scheduleList: [],
      procedureList: [],
      step: 0,
      scheduleInfo: {},
      detailsObj: null
    };
  },
  created() {
    this.getInfoFun();
  },
  methods: {
    async getInfoFun() {
      const res = await auditScheduleResource({
        auditFlowTypeId: this.$route.params.auditFlowTypeId
      });
      if (res.length != 0) {
        this.procedureList = res;
        this.procedureList.unshift({
          iconName: 'container',
          id: -1,
          name: this.$t('报案理赔')
        });
      }
      this.getscheduleFun();
    },
    goInfoFun(val) {
      this.scheduleInfo = val;
      this.stepFun();
      this.detailFun();
    },
    async detailFun() {
      this.detailsObj = null;
      const res = await auditDetail({
        auditScheduleId: this.scheduleInfo.id
      });
      console.log(res);
      this.detailsObj = res;
    },
    async onSubmit(val) {
      let editableArea = '';
      if (this.detailsObj.editableAreaInfo.length != 0) {
        const cont = recursionCopy(this.$refs.operation.editableAreaInfo);
        let implement = true;
        for (var i = 0; i < cont.length; i++) {
          if (cont[i].controlType != 'table') {
            for (let j = 0; j < cont[i].control.length; j++) {
              if (cont[i].control[j].other == 1 && !cont[i].control[j].value) {
                this.$message.error(this.$t('请完善') + this.$t(cont[i].control[j].controlName) + this.$t('信息'));
                implement = false;
                break;
              } else if (cont[i].control[j].partsType == 'multipleChoice' && cont[i].control[j].value) {
                const value = cont[i].control[j].value.join(',');
                cont[i].control[j].value = value;
              } else if (cont[i].control[j].partsType == 'dateRange' && cont[i].control[j].value) {
                cont[i].control[j].value = cont[i].control[j].value.join('/');
              } else if ((cont[i].control[j].partsType == 'enclosure' || cont[i].control[j].partsType == 'picture') && cont[i].control[j].other == 1 && cont[i].control[j].value.length == 0) {
                console.log(33);
                this.$message.error(this.$t('请上传') + this.$t(cont[i].control[j].controlName) + this.$t('信息'));
                implement = false;
                break;
              }
            }
          } else if (cont[i].controlType == 'table' && cont[i].operation == 'addEditDel') {
            if (cont[i].value.length == 0) {
              this.$message.error(this.$t('至少添加一条配件明细'));
              implement = false;
              break;
            }
          }
          // else if (cont[i].controlType == 'table' && (cont[i].operation == 'lossDetermination' || cont[i].operation == 'nuclearDamage')) {
          //   let name = cont[i].operation == 'lossDetermination' ? 'loss' : 'damage';
          //   for (let j = 0; j < cont[i].value.length; j++){
          //     if (!cont[i].value[j][name]) {
          //       this.$message.error('请完善'+cont[i].control[cont[i].control.length-1].title);
          //       implement = false;
          //       break;
          //     }
          //   }
          // }
          if (!implement) {
            break; //跳出外面这层
          }
        }
        if (!implement) {
          return false;
        }
        const cont2 = cont.map(item => {
          delete item.delete;
          if (item.controlType == 'table') {
            item.control.map(con => {
              con.slots = {
                title: con.title
              };
              delete con.title;
              return con;
            });
          }
          if (item.controlType == 'table' && item.operation == 'addEditDel') {
            item.control.pop();
          } else if (item.controlType == 'table' && item.operation == 'lossDetermination') {
            item.control.splice(item.control.length - 1, 1, {
              slots: {
                title: this.$t('定损意见')
              },
              dataIndex: 'loss',
              key: '7',
              align: 'center'
            });
          } else if (item.controlType == 'table' && item.operation == 'nuclearDamage') {
            item.control.splice(item.control.length - 1, 1, {
              slots: {
                title: this.$t('核损意见')
              },
              dataIndex: 'damage',
              key: '8',
              align: 'center'
            });
          }
          return item;
        });
        console.log(cont2);
        editableArea = JSON.stringify(cont2);
      }
      // console.log(JSON.parse(editableArea));
      await auditOperate({
        auditScheduleId: this.scheduleInfo.id,
        editableArea: editableArea,
        goBack: val.goBack,
        specifiedNode: val.node
      });
      this.getscheduleFun();
    },
    async getscheduleFun() {
      this.scheduleList = await auditSchedule({
        auditFlowDetailId: this.$route.params.id
      });
      this.scheduleInfo = this.scheduleList[this.scheduleList.length - 1];
      if (!this.scheduleInfo.currentScheduleOperator && !this.scheduleInfo.operationAt && this.scheduleInfo.step == '0') {
        this.scheduleInfo = this.scheduleList[this.scheduleList.length - 2];
      }
      this.stepFun();
      this.detailFun();
    },
    perfectOk() {
      this.getscheduleFun();
    },
    stepFun() {
      this.step = this.procedureList.findIndex(val => {
        return val.id == this.scheduleInfo.auditFlowScheduleId;
      });
      if (this.step == -1) {
        this.step = 0;
      }
    }
  }
};